import React from 'react';
import { Flex, Text } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import { colors, borders, gradients } from 'style/config';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { isGenAINewUIEnabledWithRCPS } from 'ai/utils/aiBeautyChat';

const { getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('ai/components/SuperChat/locales', 'SuperChat');

function SuperChatFlyout({ isOpen, onShowFeedback }) {
    if (!isOpen) {
        return null;
    }

    const handleShareFeedbackClick = () => {
        if (onShowFeedback) {
            onShowFeedback();
        }
    };

    const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

    return (
        <Flex
            position='absolute'
            top='50px'
            left='0'
            right='0'
            bottom='0'
            backgroundColor='white'
            flexDirection='column'
            css={[styles.fullPageOverlay, isGenAINewUIEnabled && styles.fullPageOverlayNewUI]}
        >
            <Flex
                alignSelf='stretch'
                padding={4}
                css={[styles.menuItem, isGenAINewUIEnabled && styles.menuItemNewUI]}
                onClick={handleShareFeedbackClick}
            >
                <Text
                    fontSize='sm'
                    fontWeight='bold'
                    color={colors.darkGray}
                >
                    {getText('shareFeedback')}
                </Text>
            </Flex>
        </Flex>
    );
}

const styles = {
    fullPageOverlay: {
        '@keyframes slideIn': {
            '0%': {
                transform: 'translateX(100%)'
            },
            '100%': {
                transform: 'translateX(0)'
            }
        },
        animationName: 'slideIn',
        animationDuration: '300ms',
        animationTimingFunction: 'ease-out',
        zIndex: 1
    },
    fullPageOverlayNewUI: {
        background: gradients.aiBeautyChat
    },
    menuItem: {
        cursor: 'pointer',
        borderBottom: `${borders[1]} ${colors.lightGray}`
    },
    menuItemNewUI: {
        borderBottom: 'none'
    }
};

export default wrapFunctionalComponent(SuperChatFlyout, 'SuperChatFlyout');
